import type { SymbolLandEffect, SymbolLandAnimationRequest } from "./SymbolLandEffect";

/**
 * Several `SymbolLandEffect`s for every just-landed symbol — the land-side analogue of
 * `CompositeSymbolWinEffect`. Each child animates the symbols it targets and skips the rest.
 */
export class CompositeSymbolLandEffect implements SymbolLandEffect {
  public constructor(private readonly effects: readonly SymbolLandEffect[]) {}

  public play(request: SymbolLandAnimationRequest): void {
    for (const effect of this.effects) effect.play(request);
  }

  public finishAll(): void {
    for (const effect of this.effects) effect.finishAll();
  }
}
